import PropTypes from "prop-types";

export const chartShape = PropTypes.shape({
  context: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  open: PropTypes.func,
});

const ADMISSION_VALUE = "admission";

// The series' charts in the shape the confirm's HoldsHeader and KillsHeader
// list. A lone general admission "chart" has nothing to switch to, so none show.
export const headerEvents = (charts, seated) =>
  charts.length > 1 || seated
    ? charts.map((chart) => ({
      id: chart.context || ADMISSION_VALUE,
      context: chart.context ? "add_on" : "admission",
      seating_chart_name: chart.name || "General admission",
    }))
    : [];

export const contextFromEvent = (value) => (value === ADMISSION_VALUE ? null : value);
